import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/what_traders_say/stars-5-filled.svg")